import { Grid, GridItem } from '@chakra-ui/react';
import WrapperFieldForm from './Fields/FieldForm';
import { CustomFormV3Props } from './types';

export const CustomFormV3 = ({ layout, gridProps = {} }: CustomFormV3Props) => {
  return (
    <Grid templateColumns="repeat(12, 1fr)" gap={2} width="100%" {...gridProps}>
      {layout.map((field, i) => (
        <GridItem key={i} colSpan={field.size || 4}>
          <WrapperFieldForm field={field} />
        </GridItem>
      ))}
    </Grid>
  );
};
